import React, {useState} from 'react'
import axios from "axios";
import {APIURL} from "../../../Global";
import {Modal} from 'react-bootstrap';
import {Button} from 'react-bootstrap';

function ShipEdit (props) {
    

    const [charge, setCharge]=useState(props.seteditship !== " " ? props.seteditship : " ")
    const [modalShow, setModalShow]=useState(false)
    const [errorMsg, setErrorMsg] = useState("");
    const [errorSubmit, setErrorSubmit] = useState(false);
  const id =props.id;
    const handleChange = (e)=> {
        const val = e.target.value
     
            setCharge(e.target.value)
         }

  const handleShipEdit = () => {

           

           if(charge<0){
            setErrorMsg("Negative Values not allowed!!!");
            setErrorSubmit(true);
           }
           if(charge=="0"){
            setErrorMsg("Zero Values not allowed!!!");
            setErrorSubmit(true);
           }
    if(charge!="0"){
                const id =props.id
            const tokenString= sessionStorage.getItem('usertoken');
       
            let str= tokenString.replace(/["]+/g, '');
             
             
           const dataToUpdate = 
               {
                   "charge": charge
               }
         
         
           
             axios.put(`${APIURL}/api/v1/service-provider/shipping-charge-detail/${id}/`,dataToUpdate, { headers: {
               
               "Authorization" : 'Token '+str,
               'Content-Type': 'application/json'  }
         
         
             })
         
         
         
             .then(res=>{
            
               if(res.data.status==="success"){
                    setModalShow(true)
                    //setCharge(" ")
               }
          
             })
             .catch(err=>{
           
               
         })
        }
            }
      const SubmitPopup =(props)=>{
    

                return (
                  <Modal
                    {...props}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                     backdrop="static"
                      keyboard={false}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title id="contained-modal-title-vcenter">
                       
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <h5 className='text-success'>Shipping Charge Edited Successfully !!</h5>
                     
                    </Modal.Body>
                    <Modal.Footer>
                     
                       <Button variant="secondary" onClick={props.onHide}>Ok</Button>
              
                     
                     
              
                    </Modal.Footer>
                  </Modal>
                );
              } 
              const ErrorPopup =(props)=>{
    

                return (
                  <Modal
                    {...props}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                     backdrop="static"
                      keyboard={false}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title id="contained-modal-title-vcenter">
                       
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <h5 style={{color: "red"}}> Error in data submission.Please check again!</h5>
                     
                    </Modal.Body>
                    <Modal.Footer>
                     
                       <Button variant="secondary" onClick={props.onHide}>Ok</Button>
              
                     
                     
              
                    </Modal.Footer>
                  </Modal>
                );
              }
              const SubmitErrorPopup = (props) => {
                return (
                  <Modal
                    {...props}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    backdrop="static"
                    keyboard={false}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <h5 style={{ color: "red" }}>
                      {errorMsg}
                      </h5>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={props.onHide}>
                        Ok
                      </Button>
                    </Modal.Footer>
                  </Modal>
                );
              };
        
        return (<> <label>Edit Shipping Charge:</label>
            <div className='flex-col' style={{display:"flex",flexDirection: "row"}}>
             

<input
                    type="number"
                    name="charge"
                    min="0"
                    value={charge}
                    onChange={handleChange}
                    required
                ></input>  
                <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>

<button  onClick={handleShipEdit} className='btn btn-primary btn-col'>Update</button> 

</div>
{
        modalShow ? 
        <SubmitPopup
          show={modalShow}
          onHide= {() => { 
            setModalShow(false); 
            props.submiteditship(); 
          }}
        /> : null
      }
      {errorMsg !== "" ? (
        <SubmitErrorPopup
          show={errorSubmit}
          onHide={() => setErrorSubmit(false)}
        />
      ) : (
        ""
      )}
               
               </>

        )

}

export default ShipEdit;
